import { render, staticRenderFns } from "./invoiceRecordDetailOrder.vue?vue&type=template&id=b5d553fe&scoped=true&"
import script from "./invoiceRecordDetailOrder.vue?vue&type=script&lang=js&"
export * from "./invoiceRecordDetailOrder.vue?vue&type=script&lang=js&"
import style0 from "./invoiceRecordDetailOrder.vue?vue&type=style&index=0&id=b5d553fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d553fe",
  null
  
)

export default component.exports